import React from "react";
import {
  HeroBarberImage,
  HeroHairstylistImage,
  HeroMakeupImage,
} from "../../assets";
import { Container } from "../../components";

const Benefits = () => {
  return (
    <section className="py-12 lg:py-24 px-6">
      <Container size="lg">
        <div className="w-fit mx-auto border-2 border-black text-sm px-4 py-3 rounded-[40px] mb-4">
          Benefits
        </div>
        <h2 className="text-4xl text-center max-w-[600px] mx-auto">
          Empowering health &amp; beauty Heros to{" "}
          <span className="gradient-text">maximize profits and well-being</span>{" "}
        </h2>
        <div className="grid gap-10 md:gap-[52px] md:grid-cols-2 mt-14 items-center">
          <div className="grid grid-cols-3 gap-3 sm:gap-4 h-[340px] sm:h-[420px] lg:h-[520px] min-w-0">
            <img
              src={HeroBarberImage}
              className="w-full h-full object-cover rounded-2xl lg:rounded-3xl"
              alt="Barber Hero ready for health and beauty bookings on Meind"
              loading="lazy"
            />
            <img
              src={HeroHairstylistImage}
              className="w-full h-full object-cover rounded-2xl lg:rounded-3xl"
              alt="Hairstylist Hero offering beauty services through Meind"
              loading="lazy"
            />
            <img
              src={HeroMakeupImage}
              className="w-full h-full object-cover rounded-2xl lg:rounded-3xl"
              alt="Makeup artist Hero providing beauty appointments on Meind"
              loading="lazy"
            />
          </div>
          <div className="lg:max-w-[285px]">
            <div className="pb-4">
              <h3 className="font-medium text-lg lg:text-xl mb-2">
                User-Friendly Interface
              </h3>
              <p className="mb-8">
                Simple registration and profile creation for clients and health
                and beauty providers, with social login support.
              </p>
              <div className="gradient-line" />
            </div>
            <div className="pb-4">
              <h3 className="font-medium text-lg lg:text-xl mb-2">
                Hero Management
              </h3>
              <p className="mb-10">
                Verified Hero profiles for wellness, spa, massage, and beauty
                professionals; manage availability and client onboarding.
              </p>
              <div className="gradient-line" />
            </div>
            <div>
              <h3 className="font-medium text-lg lg:text-xl mb-2">
                Booking and Scheduling
              </h3>
              <p>
                Easy health and beauty appointment scheduling with real-time
                availability and instant booking.
              </p>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Benefits;
